// extracted by mini-css-extract-plugin
export var readonly = "_he-1";
export var star = "_he-0";